<template>
  <div class="w-full flex mb-4">
    <div class="w-full flex mr-2">
      <l-info-box class="" :active="show">Right click a row to edit, delete or add a new record</l-info-box>
    </div>
    <div class="flex mr-2">
      <div class="flex w-full justify-end" v-show="show">
        <l-button type="success" :disabled="false" @click="onExport">Export to csv</l-button>
      </div>
    </div>
  </div>
</template>

<script>
import { LInput, LButton, LUpload } from "@/components/forms";
import LInfoBox from "@/components/LInfoBox";

export default {
  name: "LCsvExport",
  props: ["exportPlugin", "show", "filename"],
  components: {
    LInput,
    LButton,
    LUpload,
    LInfoBox
  },
  data() {
    return {
      file: {},
    };
  },
  methods: {
    onExport() {
      this.exportPlugin.downloadFile("csv", {
        filename: this.filename,
        columnHeaders: true, // default false, exports the column headers
        columnDelimiter: ";", // default ',', the data delimiter
      });
    },
  },
};
</script>